import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'ConfirmationModalContainer'

    static propTypes = {
      confirmationModalHide: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      message: PropTypes.string.isRequired,
      onAccept: PropTypes.shape({
        meta: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
      }).isRequired,
    }

    handleAccept = () => {
      const { confirmationModalHide, dispatch, onAccept } = this.props

      confirmationModalHide()
      dispatch(onAccept)
    }

    handleClose = () => {
      const { confirmationModalHide } = this.props

      confirmationModalHide()
    }

    render() {
      return <WrappedComponent handleAccept={this.handleAccept} handleClose={this.handleClose} message={this.props.message} />
    }
  }

  return Container
}
